/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { CoreUiCommonModule, CoreUiDialogsModule, CoreUiWaitingModule, NotificationService } from '@gh/core-ui';
import { CommonSharedModule } from '@gh/common-shared';
import { ExtConfirmationDialogComponent, ExtDialogButtonBarComponent, ExtDialogComponent, ExtDialogContentComponent, ExtDialogHeaderComponent, ExtEversignDialogComponent, ExtEversignDocumentComponent, ExtLoadTrackerComponent, ExtMessageDialogComponent, ExtNavigationComponent, ExtNavigationItemComponent, ExtNoDataComponent, ExtNotFoundPageComponent, ExtPageComponent, ExtPageContentComponent, ExtPageTitleDirective, ExtPreloaderComponent, ExtRootLayoutComponent, ExtUploaderComponent, } from './components';
import { ExtIfQueryDirective } from './directives';
import { ExtInfiniteListComponent, ExtInfiniteListItemComponent, ExtInfiniteRowDirective, ExtInfiniteScrollForDirective, ExtInfiniteScrollViewportDirective, ExtInfiniteTableDirective, ExtInfiniteTableViewerDirective, } from './infinite-scroll';
import { MaterialExternalModule } from './material-external.module';
import { ExtNotificationService } from './services/ext-notification.service';
import { ExtUploaderService } from './services/ext-uploader.service';
import { ConnectPipe } from './table';
import * as i0 from "@angular/core";
import * as i1 from "@angular/flex-layout";
import * as i2 from "../common-shared/common-shared.module";
import * as i3 from "../core-ui/common/core-ui-common.module";
import * as i4 from "../core-ui/dialogs/core-ui-dialogs.module";
import * as i5 from "../core-ui/waiting/core-ui-waiting.module";
import * as i6 from "@angular/flex-layout/flex";
import * as i7 from "@angular/flex-layout/extended";
import * as i8 from "@angular/flex-layout/grid";
import * as i9 from "@angular/common";
import * as i10 from "@angular/router";
import * as i11 from "../core-mls/components/message-repository/message-repository.component";
import * as i12 from "../core-mls/components/message-repository/message.directive";
import * as i13 from "../core-type/directives/data-type.directive";
import * as i14 from "../core-type/directives/masked-type.directive";
import * as i15 from "../core-type/directives/number-type.directive";
import * as i16 from "../core-type/directives/date-type.directive";
import * as i17 from "../core-type/directives/quantity-type.directive";
import * as i18 from "../common-shared/auth/allow-for.directive";
import * as i19 from "../common-shared/auth/forbid-for.directive";
import * as i20 from "../common-shared/state/directives/container-state.directive";
import * as i21 from "../common-shared/state/directives/container-async-disabled.directive";
import * as i22 from "../common-shared/state/form/directives/if-control-visible.directive";
import * as i23 from "../common-shared/routing/router-back.directive";
import * as i24 from "../common-shared/routing/app-router-outlet.directive";
import * as i25 from "../common-shared/help/help-id.directive";
import * as i26 from "../core-ui/common/directives/infinite-scroll.directive";
import * as i27 from "../core-ui/common/directives/automation-id.directive";
import * as i28 from "../core-ui/common/directives/ellipsis.directive";
import * as i29 from "../core-ui/common/directives/focus.directive";
import * as i30 from "../core-ui/common/directives/focus-on-init.directive";
import * as i31 from "../core-ui/common/directives/capture-event.directive";
import * as i32 from "../core-ui/common/directives/event-stop-propagation.directive";
import * as i33 from "../core-ui/common/directives/renderer.directive";
import * as i34 from "../core-ui/common/directives/local.directive";
import * as i35 from "../core-ui/common/components/template-site/template-site.component";
import * as i36 from "../core-ui/waiting/waiting-scope.directive";
import * as i37 from "../core-ui/waiting/wait.directive";
import * as i38 from "@angular/material/icon";
import * as i39 from "@angular/cdk/bidi";
import * as i40 from "@angular/cdk/scrolling";
import * as i41 from "@angular/material/form-field";
import * as i42 from "@angular/material/select";
import * as i43 from "@angular/material/core";
import * as i44 from "@angular/material/button";
import * as i45 from "@angular/material/tooltip";
import * as i46 from "@angular/material/sort";
import * as i47 from "@angular/material/table";
import * as i48 from "@angular/material/card";
import * as i49 from "@angular/material/slide-toggle";
import * as i50 from "@angular/cdk/table";
import * as i51 from "@angular/material/dialog";
import * as i52 from "@angular/material/progress-spinner";
import * as i53 from "@angular/material/progress-bar";
import * as i54 from "@angular/material/snack-bar";
import * as i55 from "../core-mls/translation/translate.pipe";
import * as i56 from "../core-type/pipes/type-format.pipe";
import * as i57 from "../common-shared/auth/has-permission.pipe";
import * as i58 from "../common-shared/state/form/pipes/is-control-required.pipe";
import * as i59 from "../common-shared/state/form/pipes/is-control-visible.pipe";
import * as i60 from "../common-shared/pipes/duration.pipe";
import * as i61 from "../core-ui/common/pipes/sanitize.pipe";
import * as i62 from "../core-ui/common/pipes/highlight.pipe";
import * as i63 from "../core-ui/common/pipes/html-with-urls.pipe";
import * as i64 from "../core-ui/common/pipes/text-with-urls.pipe";
import * as i65 from "../core-ui/common/pipes/keys.pipe";
import * as i66 from "../core-ui/common/pipes/to-array.pipe";
import * as i67 from "../core-ui/common/pipes/in-context.pipe";
import * as i68 from "../core-ui/common/pipes/pluck$.pipe";
import * as i69 from "../core-ui/common/pipes/default-currency.pipe";
import * as i70 from "../core-ui/common/pipes/log.pipe";
/**
 * Technique described by this link does not work in AoT mode for our configuration
 * https://github.com/benbraou/flex-layout-wiki/blob/master/Custom-Breakpoints.md.
 *
 * So we duplicate array of breakpoints to customize them.
 */
export var DEFAULT_BREAKPOINTS = [
    {
        alias: 'xs',
        mediaQuery: '(min-width: 0px) and (max-width: 599px)',
    },
    {
        alias: 'gt-xs',
        overlapping: true,
        mediaQuery: '(min-width: 600px)',
    },
    {
        alias: 'lt-sm',
        overlapping: true,
        mediaQuery: '(max-width: 599px)',
    },
    {
        alias: 'sm',
        mediaQuery: '(min-width: 600px) and (max-width: 959px)',
    },
    {
        alias: 'gt-sm',
        overlapping: true,
        mediaQuery: '(min-width: 960px)',
    },
    {
        alias: 'lt-md',
        overlapping: true,
        mediaQuery: '(max-width: 959px)',
    },
    {
        alias: 'md',
        mediaQuery: '(min-width: 960px) and (max-width: 1279px)',
    },
    {
        alias: 'gt-md',
        overlapping: true,
        mediaQuery: '(min-width: 1280px)',
    },
    {
        alias: 'lt-lg',
        overlapping: true,
        mediaQuery: '(max-width: 1279px)',
    },
    {
        alias: 'lg',
        mediaQuery: '(min-width: 1280px) and (max-width: 1599px)',
    },
    {
        alias: 'gt-lg',
        overlapping: true,
        mediaQuery: '(min-width: 1600px)',
    },
    {
        alias: 'lt-xl',
        overlapping: true,
        mediaQuery: '(max-width: 1599px)',
    },
    {
        alias: 'xl',
        mediaQuery: '(min-width: 1600px) and (max-width: 5000px)',
    },
];
var CommonExternalSharedModule = /** @class */ (function () {
    function CommonExternalSharedModule() {
    }
    CommonExternalSharedModule.forRoot = function () {
        return {
            ngModule: CommonExternalSharedModule,
            providers: [
                {
                    provide: MAT_DIALOG_DEFAULT_OPTIONS,
                    useValue: { maxWidth: '100%', maxHeight: '100%', hasBackdrop: true, autoFocus: true },
                },
                { provide: NotificationService, useClass: ExtNotificationService },
            ],
        };
    };
    CommonExternalSharedModule.forChild = function () {
        return { ngModule: CommonExternalSharedModule };
    };
    CommonExternalSharedModule.ɵmod = i0.ɵɵdefineNgModule({ type: CommonExternalSharedModule });
    CommonExternalSharedModule.ɵinj = i0.ɵɵdefineInjector({ factory: function CommonExternalSharedModule_Factory(t) { return new (t || CommonExternalSharedModule)(); }, providers: [
            ExtUploaderService,
        ], imports: [[
                FlexLayoutModule.withConfig({ disableDefaultBps: true }, DEFAULT_BREAKPOINTS),
                CommonSharedModule.forChild(),
                CoreUiCommonModule.forChild(),
                CoreUiDialogsModule.forChild(),
                CoreUiWaitingModule.forChild(),
                MaterialExternalModule,
            ],
            FlexLayoutModule,
            CommonSharedModule,
            CoreUiCommonModule,
            CoreUiDialogsModule,
            MaterialExternalModule] });
    return CommonExternalSharedModule;
}());
export { CommonExternalSharedModule };
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CommonExternalSharedModule, { declarations: [ExtIfQueryDirective,
        ExtNavigationComponent,
        ExtNavigationItemComponent,
        ExtRootLayoutComponent,
        ExtPageComponent,
        ExtPageTitleDirective,
        ExtPageContentComponent,
        ExtNotFoundPageComponent,
        ExtNoDataComponent,
        ExtEversignDocumentComponent,
        ExtEversignDialogComponent,
        ExtPreloaderComponent,
        ExtDialogComponent,
        ExtDialogHeaderComponent,
        ExtDialogButtonBarComponent,
        ExtDialogContentComponent,
        ExtInfiniteTableDirective,
        ExtInfiniteScrollViewportDirective,
        ExtInfiniteScrollForDirective,
        ExtInfiniteListComponent,
        ExtInfiniteListItemComponent,
        ExtInfiniteTableViewerDirective,
        ExtInfiniteRowDirective,
        ExtUploaderComponent,
        ExtLoadTrackerComponent,
        ExtConfirmationDialogComponent,
        ExtMessageDialogComponent,
        ConnectPipe], imports: [i1.FlexLayoutModule, i2.CommonSharedModule, i3.CoreUiCommonModule, i4.CoreUiDialogsModule, i5.CoreUiWaitingModule, MaterialExternalModule], exports: [ExtIfQueryDirective,
        ExtNavigationComponent,
        ExtNavigationItemComponent,
        ExtRootLayoutComponent,
        ExtPageComponent,
        ExtPageTitleDirective,
        ExtPageContentComponent,
        ExtNotFoundPageComponent,
        ExtNoDataComponent,
        ExtEversignDocumentComponent,
        ExtPreloaderComponent,
        ExtDialogComponent,
        ExtDialogHeaderComponent,
        ExtDialogButtonBarComponent,
        ExtDialogContentComponent,
        ExtInfiniteTableDirective,
        ExtInfiniteScrollViewportDirective,
        ExtInfiniteTableViewerDirective,
        ExtInfiniteRowDirective,
        ExtInfiniteListComponent,
        ExtInfiniteListItemComponent,
        ExtInfiniteScrollForDirective,
        ExtUploaderComponent,
        ExtLoadTrackerComponent,
        FlexLayoutModule,
        CommonSharedModule,
        CoreUiCommonModule,
        CoreUiDialogsModule,
        MaterialExternalModule,
        ConnectPipe] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(CommonExternalSharedModule, [{
        type: NgModule,
        args: [{
                imports: [
                    FlexLayoutModule.withConfig({ disableDefaultBps: true }, DEFAULT_BREAKPOINTS),
                    CommonSharedModule.forChild(),
                    CoreUiCommonModule.forChild(),
                    CoreUiDialogsModule.forChild(),
                    CoreUiWaitingModule.forChild(),
                    MaterialExternalModule,
                ],
                providers: [
                    ExtUploaderService,
                ],
                declarations: [
                    ExtIfQueryDirective,
                    ExtNavigationComponent,
                    ExtNavigationItemComponent,
                    ExtRootLayoutComponent,
                    ExtPageComponent,
                    ExtPageTitleDirective,
                    ExtPageContentComponent,
                    ExtNotFoundPageComponent,
                    ExtNoDataComponent,
                    ExtEversignDocumentComponent,
                    ExtEversignDialogComponent,
                    ExtPreloaderComponent,
                    ExtDialogComponent,
                    ExtDialogHeaderComponent,
                    ExtDialogButtonBarComponent,
                    ExtDialogContentComponent,
                    ExtInfiniteTableDirective,
                    ExtInfiniteScrollViewportDirective,
                    ExtInfiniteScrollForDirective,
                    ExtInfiniteListComponent,
                    ExtInfiniteListItemComponent,
                    ExtInfiniteTableViewerDirective,
                    ExtInfiniteRowDirective,
                    ExtUploaderComponent,
                    ExtLoadTrackerComponent,
                    ExtConfirmationDialogComponent,
                    ExtMessageDialogComponent,
                    ConnectPipe,
                ],
                entryComponents: [
                    ExtInfiniteListItemComponent,
                    ExtEversignDialogComponent,
                    ExtConfirmationDialogComponent,
                    ExtMessageDialogComponent,
                ],
                exports: [
                    ExtIfQueryDirective,
                    ExtNavigationComponent,
                    ExtNavigationItemComponent,
                    ExtRootLayoutComponent,
                    ExtPageComponent,
                    ExtPageTitleDirective,
                    ExtPageContentComponent,
                    ExtNotFoundPageComponent,
                    ExtNoDataComponent,
                    ExtEversignDocumentComponent,
                    ExtPreloaderComponent,
                    ExtDialogComponent,
                    ExtDialogHeaderComponent,
                    ExtDialogButtonBarComponent,
                    ExtDialogContentComponent,
                    ExtInfiniteTableDirective,
                    ExtInfiniteScrollViewportDirective,
                    ExtInfiniteTableViewerDirective,
                    ExtInfiniteRowDirective,
                    ExtInfiniteListComponent,
                    ExtInfiniteListItemComponent,
                    ExtInfiniteScrollForDirective,
                    ExtUploaderComponent,
                    ExtLoadTrackerComponent,
                    FlexLayoutModule,
                    CommonSharedModule,
                    CoreUiCommonModule,
                    CoreUiDialogsModule,
                    MaterialExternalModule,
                    ConnectPipe,
                ],
            }]
    }], null, null); })();
i0.ɵɵsetComponentScope(ExtNotFoundPageComponent, [i6.DefaultLayoutDirective, i6.DefaultLayoutGapDirective, i6.DefaultLayoutAlignDirective, i6.DefaultFlexOrderDirective, i6.DefaultFlexOffsetDirective, i6.FlexFillDirective, i6.DefaultFlexAlignDirective, i6.DefaultFlexDirective, i7.DefaultShowHideDirective, i7.DefaultClassDirective, i7.DefaultStyleDirective, i7.DefaultImgSrcDirective, i8.ɵgrid_privatec, i8.ɵgrid_privatef, i8.ɵgrid_privatei, i8.ɵgrid_privatel, i8.ɵgrid_privateo, i8.ɵgrid_privater, i8.ɵgrid_privateu, i8.ɵgrid_privatex, i8.ɵgrid_privateba, i8.ɵgrid_privatebd, i8.ɵgrid_privatebg, i9.NgClass, i9.NgComponentOutlet, i9.NgForOf, i9.NgIf, i9.NgTemplateOutlet, i9.NgStyle, i9.NgSwitch, i9.NgSwitchCase, i9.NgSwitchDefault, i9.NgPlural, i9.NgPluralCase, i10.RouterOutlet, i10.RouterLink, i10.RouterLinkWithHref, i10.RouterLinkActive, i10.ɵangular_packages_router_router_l, i11.MessageRepositoryComponent, i12.MessageDirective, i13.DataTypeDirective, i14.MaskedTypeDirective, i15.NumberTypeDirective, i16.DateTypeDirective, i17.QuantityTypeDirective, i18.AllowForDirective, i19.ForbidForDirective, i20.ContainerStateDirective, i21.ContainerAsyncDisabledDirective, i22.IfControlVisibleDirective, i23.RouterBackDirective, i24.AppRouterOutletDirective, i25.HelpIdDirective, i26.InfiniteScrollDirective, i27.AutomationIDDirective, i28.EllipsisDirective, i29.FocusDirective, i30.FocusOnInitDirective, i31.CaptureEventDirective, i32.EventStopPropagationDirective, i33.RendererDirective, i34.LocalDirective, i35.TemplateSiteComponent, i36.WaitingScopeDirective, i37.WaitDirective, i38.MatIcon, i39.Dir, i40.CdkScrollable, i41.MatError, i41.MatFormField, i41.MatHint, i41.MatLabel, i41.MatPlaceholder, i41.MatPrefix, i41.MatSuffix, i42.MatSelect, i42.MatSelectTrigger, i43.MatOption, i43.MatOptgroup, i44.MatButton, i44.MatAnchor, i45.MatTooltip, i45.TooltipComponent, i43.MatRipple, i46.MatSort, i46.MatSortHeader, i47.MatTable, i47.MatHeaderCellDef, i47.MatHeaderRowDef, i47.MatColumnDef, i47.MatCellDef, i47.MatRowDef, i47.MatFooterCellDef, i47.MatFooterRowDef, i47.MatHeaderCell, i47.MatCell, i47.MatFooterCell, i47.MatHeaderRow, i47.MatRow, i47.MatFooterRow, i47.MatTextColumn, i48.MatCard, i48.MatCardHeader, i48.MatCardTitleGroup, i48.MatCardContent, i48.MatCardTitle, i48.MatCardSubtitle, i48.MatCardActions, i48.MatCardFooter, i48.MatCardSmImage, i48.MatCardMdImage, i48.MatCardLgImage, i48.MatCardImage, i48.MatCardXlImage, i48.MatCardAvatar, i49.MatSlideToggleRequiredValidator, i49.MatSlideToggle, i50.CdkTable, i50.CdkRowDef, i50.CdkCellDef, i50.CdkCellOutlet, i50.CdkHeaderCellDef, i50.CdkFooterCellDef, i50.CdkColumnDef, i50.CdkCell, i50.CdkRow, i50.CdkHeaderCell, i50.CdkFooterCell, i50.CdkHeaderRow, i50.CdkHeaderRowDef, i50.CdkFooterRow, i50.CdkFooterRowDef, i50.DataRowOutlet, i50.HeaderRowOutlet, i50.FooterRowOutlet, i50.CdkTextColumn, i51.MatDialogContainer, i51.MatDialogClose, i51.MatDialogTitle, i51.MatDialogContent, i51.MatDialogActions, i52.MatProgressSpinner, i52.MatSpinner, i53.MatProgressBar, i54.MatSnackBarContainer, ExtIfQueryDirective,
    ExtNavigationComponent,
    ExtNavigationItemComponent,
    ExtRootLayoutComponent,
    ExtPageComponent,
    ExtPageTitleDirective,
    ExtPageContentComponent,
    ExtNotFoundPageComponent,
    ExtNoDataComponent,
    ExtEversignDocumentComponent,
    ExtEversignDialogComponent,
    ExtPreloaderComponent,
    ExtDialogComponent,
    ExtDialogHeaderComponent,
    ExtDialogButtonBarComponent,
    ExtDialogContentComponent,
    ExtInfiniteTableDirective,
    ExtInfiniteScrollViewportDirective,
    ExtInfiniteScrollForDirective,
    ExtInfiniteListComponent,
    ExtInfiniteListItemComponent,
    ExtInfiniteTableViewerDirective,
    ExtInfiniteRowDirective,
    ExtUploaderComponent,
    ExtLoadTrackerComponent,
    ExtConfirmationDialogComponent,
    ExtMessageDialogComponent], [i9.AsyncPipe, i9.UpperCasePipe, i9.LowerCasePipe, i9.JsonPipe, i9.SlicePipe, i9.DecimalPipe, i9.PercentPipe, i9.TitleCasePipe, i9.CurrencyPipe, i9.DatePipe, i9.I18nPluralPipe, i9.I18nSelectPipe, i9.KeyValuePipe, i55.TranslatePipe, i56.TypeFormatPipe, i57.HasPermissionPipe, i58.IsControlRequiredPipe, i59.IsControlVisiblePipe, i60.DurationPipe, i61.SanitizeHtmlPipe, i61.SanitizeUrlPipe, i62.HighlightPipe, i63.HtmlWithUrlsPipe, i64.TextWithUrlsPipe, i65.KeysPipe, i66.ToArrayPipe, i67.InContextPipe, i68.Pluck$Pipe, i69.DefaultCurrencyPipe, i70.LogPipe, ConnectPipe]);
